import {
  Component,
  Input,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { NecSlideImage } from './slide-image';
import { Router } from '@angular/router';

@Component({
  selector: 'nec-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss']
})
export class NecSlideComponent implements OnChanges, OnDestroy {
  @Input() images: NecSlideImage[];
  curShowingImageIndex: number;
  timer;

  constructor(private router: Router) {
  }

  ngOnChanges() {
    if (this.images && this.images.length >= 1) {
      this.curShowingImageIndex = 0;
    }
    this.clearTimer();
    this.autoChangeSlide();
  }

  ngOnDestroy() {
    this.clearTimer();
  }


  goToSlide(index: number) {
    this.curShowingImageIndex = index;
    this.clearTimer();
    this.autoChangeSlide();
  }

  navigateTo(link: string) {
    if (link) {
      this.router.navigate([link]);
    }
  }

  downloadBrowser() {
    let downloadUrl = 'http://ky-edu-cdn.oss-cn-shanghai.aliyuncs.com/chrome',
      os = this.detectOs(),
      bit = navigator.userAgent.match(/x86_64|Win64|WOW64/) ? 64 : 32;
    if (os.isMac) {
      downloadUrl += '/mac/latest/googlechrome.dmg';
    }
    else if (os.isWin2K || os.isWinXP || os.isWinVista) {
      if (bit === 32) {
        downloadUrl += '/windows-32/49/49.0.2623.75_chrome_installer.exe';
      }
      else {
        downloadUrl += '/windows-64/49/49.0.2623.75_chrome_installer_win64.exe';
      }
    }
    else if (os.isWin7 || os.isWin8 || os.isWin81 || os.isWin10) {
      if (bit === 32) {
        downloadUrl += '/windows-32/latest/ChromeStandaloneSetup.exe';
      }
      else {
        downloadUrl += '/windows-64/latest/ChromeStandaloneSetup64.exe';
      }
    }
    else {
      alert('åªæ¯æwindowsåmacç³»ç»Chromeæµè§å¨ä¸è½½');
    }

    if (downloadUrl.length > 0) {
      window.open().location.href = downloadUrl;
    }
  }

  /**
   * èªå¨å¾ªç¯
   */
  private autoChangeSlide() {
    this.timer = setInterval(() => {
      if (this.curShowingImageIndex >= this.images.length - 1) {
        this.curShowingImageIndex = 0;
      }
      else {
        this.curShowingImageIndex++;
      }
    }, 5000);
  }

  /**
   * æ¸æ¥å®æ¶å¨
   */
  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  private detectOs() {
    let UserAgent = navigator.userAgent.toLowerCase();
    return {
      isIpad: /ipad/.test(UserAgent),
      isIphone: /iphone os/.test(UserAgent),
      isMac: /mac os/.test(UserAgent),
      isWindows: /windows/.test(UserAgent),
      isAndroid: /android/.test(UserAgent),
      isWindowsCe: /windows ce/.test(UserAgent),
      isWindowsMobile: /windows mobile/.test(UserAgent),
      isWin2K: /windows nt 5.0/.test(UserAgent),
      isWinXP: /windows nt 5.1/.test(UserAgent),
      isWinVista: /windows nt 6.0/.test(UserAgent),
      isWin7: /windows nt 6.1/.test(UserAgent),
      isWin8: /windows nt 6.2/.test(UserAgent),
      isWin81: /windows nt 6.3/.test(UserAgent),
      isWin10: /windows nt 10.0/.test(UserAgent)
    };
  }
}
